import React, { useContext, useEffect, useState } from "react";
import { CryptoContext } from "../../CryptoContext";
import classes from "./Carousel.module.css";
import { TrendingCoins } from "../../config/api";
import axios from "axios";
import AliceCarousel from "react-alice-carousel";
import { Link } from "react-router-dom";

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Carousel = () => {
    const [trending, setTrending] = useState([]);

    const { currency, symbol } = useContext(CryptoContext);

    const items = trending.map((coin) => {
        let profit = coin.price_change_percentage_24h >= 0;
        return (
            <Link className={classes.carouselItem} to={`/coins/$${coin.id}`}>
                <img src={coin?.image} alt={coin.name} />
                <span>
                    {coin?.symbol}
                    &nbsp;
                    <span
                        style={{
                            color: profit > 0 ? "rgb(14,203,129)" : "red",
                            fontWeight: 500,
                        }}
                    >
                        {profit && "+"}
                        {coin?.price_change_percentage_24h.toFixed(2)}%
                    </span>
                </span>
                <span className={classes.price}>
                    {symbol}
                    {numberWithCommas(coin?.current_price.toFixed(2))}
                </span>
            </Link>
        );
    });

    const responsive = {
        0: {
            items: 2,
        },
        600: {
            items: 3,
            itemsFit: "contain",
        },
        800: {
            items: 4,
            itemsFit: "contain",
        }
    };

    const fetchTrendingCoins = async () => {
        const { data } = await axios.get(TrendingCoins(currency));
        setTrending(data);
    };

    useEffect(() => {
        fetchTrendingCoins();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency]);

    return (
        <div className={classes.carousel}>
            <AliceCarousel
                mouseTracking
                infinite
                autoPlayInterval={1000}
                animationDuration={1500}
                disableDotsControls
                disableButtonsControls
                responsive={responsive}
                autoPlay
                items={items}
            />
        </div>
    );
};

export default Carousel;
